import { IEvent } from "@studyportals/event-aggregation-service-interface";

export class OmniSearchFiltersUpdatedEvent implements IEvent {
	static EventType = 'OmniSearchFiltersUpdated';

	readonly timestamp: Date;
	readonly eventType: string = OmniSearchFiltersUpdatedEvent.EventType;

	constructor() {
		this.timestamp = new Date();
	}

}